import {SearchOutlined} from '@ant-design/icons';
import {Input} from 'antd';
import PropTypes from 'prop-types';

const SearchBar = ({
  value,
  onSearch,
  placeholder = 'Search...',
  width = 200,
}) => {
  return (
    <Input
      placeholder={placeholder}
      prefix={<SearchOutlined />}
      value={value} 
      onChange={e => onSearch(e.target.value)} 
      allowClear
      onPressEnter={e => onSearch(e.target.value)}
      style={{width}}
    />
  );
};

SearchBar.propTypes = {
  value: PropTypes.string, // ✅ add this
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  width: PropTypes.number,
};

export default SearchBar;
